<template>
  <section class="timeCaseListDiv">
    <viewTitle
      title="业务管理 / 车辆预约管理 / 预约时间实例"
      :showReturn="false"
    />

    <!-- 按钮组1 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%;">
        <span>使用状态: </span>
        <el-select
          clearable
          class="ctl"
          @clear="params.use_state = 0"
          v-model="params.use_state"
          placeholder="请选择使用状态"
          label="使用状态"
          @change="changeState"
        >
          <el-option
            :label="item"
            :value="index"
            v-for="(item, index) in stateOption"
            :key="index"
          ></el-option>
        </el-select>
        <!-- <el-date-picker
          v-model="params.time"
          type="date"
          placeholder="选择实例时间范围"
        >
        </el-date-picker> -->
        <el-date-picker
          v-model="params.time"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="实例开始日期"
          end-placeholder="实例结束日期"
          :picker-options="pickerOptions"
          @change="changeTimeRange"
          class="rectl"
        >
        </el-date-picker>
        <el-input
          style="width: 20% !important;margin-left: 15px;"
          clearable
          placeholder="输入模板名称搜索"
          suffix-icon="el-icon-search"
          v-model="params.keyword"
          @change="changeKeyword"
        ></el-input>
        <el-button
          class="rectl"
          type="primary"
          @click="refreshData"
          size="small"
        >
          刷新数据
        </el-button>
      </div>
    </section>

    <!-- 列表 -->
    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%;"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
      >
        <el-table-column label="模板名称">
          <template slot-scope="scope">
            {{ scope.row.model_name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="实例时间" width="170px">
          <template slot-scope="scope">
            {{ formatBookingTime(scope.row.booking_day) }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="已预约数/总号源">
          <template slot-scope="scope">
            {{ scope.row.used_number }} /
            {{ scope.row.total_number === 0 ? "不限" : scope.row.total_number }}
          </template>
        </el-table-column>
        <el-table-column label="最小可预约时间">
          <template slot-scope="scope">
            {{ formatMin(scope.row.min_booking_time) }}
          </template>
        </el-table-column>
        <el-table-column label="最大可预约时间">
          <template slot-scope="scope">
            {{ formatMax(scope.row.max_booking_day) }}
          </template>
        </el-table-column>
        <el-table-column label="使用状态">
          <template slot-scope="scope">
            <span v-if="scope.row.use_state === 1" class="colorFA">未使用</span>
            <span v-else-if="scope.row.use_state === 2" class="color5E"
              >已使用</span
            >
            <span v-else-if="scope.row.use_state === 3" class="color99"
              >已过期</span
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.update_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="dropdown" @click.stop>
              <el-dropdown trigger="click" :hide-on-click="true">
                <span class="el-dropdown-link">
                  操作
                  <span class="el-icon-arrow-down"></span>
                </span>
                <el-dropdown-menu slot="dropdown" ref="dropdown">
                  <el-dropdown-item
                    @click.native.stop="viewDetail(scope.row, 'view')"
                    >查看实例</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="viewDetail(scope.row, 'edit')"
                    v-if="scope.row.use_state !== 3"
                    >修改号源</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="page"
          :pageSize="pageSize"
          :count="count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>
  </section>
</template>

<script>
import moment from "moment";
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import keepAliveMinxin from "@/mixins/rh/keepAliveMinxin.js";

export default {
  data() {
    return {
      // module_name: "services-advice",
      tabPosition: "left",
      page: 1,
      pageSize: 50,
      count: 0, // 表格总数
      params: {
        keyword: "", // 关键字搜索
        time: [], // timepicker时间
        begin_time: "",
        end_time: "",
        use_state: 0 // 使用状态
      },
      maxSize: 0,
      tableData: [], // 表格数据
      stateOption: ["全部", "未使用", "已使用", "已过期"],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      toKeepAlivePath: "" // 当前路由访问某个页面时的不清除缓存
    };
  },

  components: {
    pagi,
    viewTitle
  },

  mixins: [mixinTableLyout, keepAliveMinxin],

  computed: {
    isOverSize() {
      return this.tableData.length > 0;
    }
  },

  mounted() {
    // setTimeout(() => {
    //   this.resizeTableHeight();
    //   window.addEventListener(
    //     "resize",
    //     e => {
    //       //  初始化表格合适高度
    //       this.resizeTableHeight();
    //       console.log(e);
    //     },
    //     false
    //   );
    // }, 500);
    // this.getList();
  },

  async activated() {
    this.getList();
  },

  created() {},

  methods: {
    // 格式化实例时间
    formatBookingTime(str) {
      let str1 = String(str);
      let colYear = str1.substring(0, 4);
      let date = `${str1.substring(0, 4)}-${str1.substring(
        4,
        6
      )}-${str1.substring(6, 8)}`;
      let day = "";
      switch (moment(date).day()) {
        case 1:
          day = "周一";
          break;
        case 2:
          day = "周二";
          break;
        case 3:
          day = "周三";
          break;
        case 4:
          day = "周四";
          break;
        case 5:
          day = "周五";
          break;
        case 6:
          day = "周六";
          break;
        case 0:
          day = "周日";
          break;
      }
      if (moment().year() === Number(colYear)) {
        return `${str1.substring(4, 6)}月${str1.substring(6, 8)}日(${day})`;
      } else {
        return `${str1.substring(0, 4)}年
          ${str1.substring(4, 6)}月
          ${str1.substring(6, 8)}日(${day})`;
      }
    },

    // 格式化最小可预约时间
    formatMin(str) {
      return `不小于${str / 60 / 60}小时`;
    },

    // 格式化最大可预约时间
    formatMax(str) {
      return `${str}天内`;
    },

    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 切换页码
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    // 关键字搜索
    changeKeyword(val) {
      this.page = 1;
      this.params.keyword = val;
      this.getList();
    },

    // 修改状态
    changeState() {
      this.page = 1;
      this.getList();
    },

    // 选择时间范围
    changeTimeRange() {
      if (this.params.time === null) {
        this.params.begin_time = "";
        this.params.end_time = "";
      } else {
        this.params.begin_time = moment(this.params.time[0]).format("YYYYMMDD");
        this.params.end_time = moment(this.params.time[1]).format("YYYYMMDD");
      }
      this.page = 1;
      this.getList();
    },

    // 获取列表
    async getList() {
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_business_time_instance",
        data: {
          use_state: this.params.use_state,
          begin_time: this.params.begin_time,
          end_time: this.params.end_time,
          keyword: this.params.keyword,
          page_size: this.pageSize,
          page: this.page
        }
      });
      console.log(dataObj.data.data);
      this.tableData = dataObj.data.data.data;
      this.count = dataObj.data.data.total;
    },

    // 刷新数据
    refreshData() {
      this.page = 1;
      this.getList();
    },

    // 查看实例
    viewDetail(row, tag) {
      console.log(row, tag);
      let route = "";
      if (tag === "view") {
        route = "/rhqy/service/appoint/timeCaseList/detail/" + row.id;
        this.toKeepAlivePath = "/rhqy/service/appoint/timeCaseList/detail/";
      } else {
        route = "/rhqy/service/appoint/timeCaseList/modify/" + row.id;
        this.toKeepAlivePath = "/rhqy/service/appoint/timeCaseList/modify/";
      }
      this.$router.push({
        path: route
      });
    }

    // 重置高度
    // resizeTableHeight() {
    //   const BANNER_HEIGHT = 44; // 头部导航高度
    //   const PADDING = 24; // padding
    //   const ETC = 200; // 头部 和 底部导航高度
    //   var offsetHeihgt = window.innerHeight - BANNER_HEIGHT - PADDING * 2;
    //   this.maxSize = offsetHeihgt - ETC;
    // }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.timeCaseListDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  & > .controler {
    display: flex;
    margin-bottom: 16px;
    .ctl {
      display: inline-block;
      width: 10% !important;
    }
    .rectl {
      margin-left: 15px;
    }
    .ctl.mid {
      width: 16% !important;
    }
    .ctl.lar {
      width: 22% !important;
    }
    .ctrRight {
      float: right;
      margin: 0;
    }
    .ctl_fix {
      margin-top: -1px;
      margin-bottom: 0;
      line-height: 18px;
      vertical-align: middle;
      padding: 0 8px 0 10px;
      .el-range__close-icon {
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
  }
  & > .main-table {
    width: 100%;
    height: calc(100% - 129px);
    position: relative;
  }
  .page-wrap {
    padding-top: 10px;
  }
}
</style>
